import { PersistContext } from "@/data/PersistProvider";
import { useEnhancedHistory } from "@/data/RouterProvider";
import { SendEvent } from "@/utils/Analytics";
import { ChannelRemind } from "@/utils/UrlHelper";
import React from "react";
import { Swiper } from "react-vant";
import style from "./style.less";

const Slides = (props) => {
  const history = useEnhancedHistory();
  const { getPersist } = React.useContext(PersistContext);
  return (
    <div class={style.container}>
      <div class={style.slide_box}>
        <Swiper
          autoplay={5000}
          loop
          touchable={true}
          style={{
            "--rv-swipe-indicator-margin": "5px",
            "--rv-swipe-indicator-inactive-background-color": "#989898",
            "--rv-swipe-indicator-active-background-color": "#f3ed93",
          }}
        >
          {props.list
            ? props.list
                .filter((item) => !item.hide)
                .map((item, index) => (
                  <Swiper.Item
                    key={index}
                    onClick={() => {
                      SendEvent(`banner_${item.name}_ad_click`, { signed_in: !!getPersist("user_info") });
                      history.push(ChannelRemind(item.link));
                    }}
                  >
                    <img key={index} class={style.slide_item} src={item.image} />
                  </Swiper.Item>
                ))
            : null}
        </Swiper>
      </div>
    </div>
  );
};

export default Slides;
